import styled from 'styled-components';

import { Overview } from '../overview';
import { SinglePropertyPrices } from '../startRegistration';
import { StartRegistration} from '../startRegistration';
import { GroupDownloadFile } from '@keaze/web/components/groupDownloadFile';
import { GroupAccordion } from '@keaze/web/components/groupAccordion';

export const StyledOverview = styled(Overview)`
  ${({ theme: { breakpoints } }) => `
    margin-top: 24px;

    ${breakpoints.up('md')} {
      margin-top: 0;
    }
  `}
`;

export const StyledGroupDownloadFile = styled(GroupDownloadFile)`
  margin-top: 24px;
`;

export const StyledGroupAccordion = styled(GroupAccordion)`
  margin-top: 24px;
`;

export const SinglePropertyBreakdown = styled(SinglePropertyPrices)`

${({ theme: { colours, breakpoints } }) => `

${breakpoints.up('md')} {    padding: 30px;}
background-color: #A0BDBE;
padding: 20px;
height:auto;
border-radius: 0;
margin-top:25px;

 div {font-weight: 700 !important; line-height: 15px !important;}
span {font-weight: 700 !important}




`}
`;

export const MobileStartRegistration = styled(StartRegistration)`
  ${({ theme: { breakpoints } }) => `

    ${breakpoints.up('md')} {
      display: none;
    }
  `}
`;

export const DesktopStartRegistration = styled(StartRegistration)`
  ${({ theme: { breakpoints } }) => `
  

    ${breakpoints.up('md')} {
      display: block;
      
    }
  `}
`;
